import { connect } from 'react-redux';

import searchActions from 'src/store/modules/search/actions';

import { SearchResultsView } from './SearchResultsView';

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onSetSearchText: (text: string) => dispatch(searchActions.search(text))
});

export const pureComponent = SearchResultsView;
export default connect(null, mapDispatchToProps)(SearchResultsView);

interface IDispatchFromProps {
  onSetSearchText: (text: string) => void;
}
